import React from "react";
import { AlertBox, TournamentPageSkeleton } from "../../../components/UI/DesignStandards";

const LoadingStates = ({ loading, teamId, tournamentId }) => {
  if (loading) {
    return (
      <TournamentPageSkeleton
        title="Edit Team"
        subtitle="Team name, bowlers, and events."
        cards={2}
      />
    );
  }

  if (!teamId || !tournamentId) {
    return (
      <div className="card-board p-8">
        <AlertBox type="error" title="Invalid Request">
          Invalid team or tournament ID
        </AlertBox>
      </div>
    );
  }

  return null;
};

export default LoadingStates;
